import { render, staticRenderFns } from "./viewreservations.vue?vue&type=template&id=53bf6320&scoped=true&"
import script from "./viewreservations.vue?vue&type=script&lang=js&"
export * from "./viewreservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bf6320",
  null
  
)

export default component.exports